// Firebase imports (for UTM Overall only)
import { child, get, ref } from "firebase/database";
import { db } from "../../firebase";

// MongoDB import
import { getDataFromMongoDb } from "../../services/mongod.data";

const getNumberOfUniqueVisitorsData = (email) => {
  // console.log("🚀 getNumberOfUniqueVisitorsData called with email:", email);
  // graphData for Number of unique visitors
  let graphData = [];
  graphData[0] = [
    {
      data: [],
      label: "",
    },
    {
      data: [],
      label: "",
    },
  ];
  graphData[1] = [];

  // helper function to fill graphData
  const fillGraphData = (data) => {
    console.log("Processing data in fillGraphData:", data);
    let week_labels = [];
    for (const [year, yearsItem] of Object.entries(data)) {
      if (year.match(/^[0-9]{4}$/)) {
        for (const [, monthValue] of Object.entries(yearsItem)) {
          for (const [, weekValue] of Object.entries(monthValue)) {
            let date =
              weekValue["year"] +
              "/" +
              weekValue["month"] +
              "/" +
              weekValue["week"];

            // console.log(weekValue);

            week_labels.push({
              [date]: {
                uniqueBrowsers: weekValue["barchart_var1"][0],
                uniqueDevices: weekValue["barchart_var2"][0],
                uniqueBrowsers_data: weekValue["barchart_var1"][1],
                uniqueDevices_data: weekValue["barchart_var2"][1],
              },
            });
          }
        }
      }
    }
    week_labels.sort((a, b) => {
      for (const [key] of Object.entries(a)) {
        return new Date(key) - new Date(Object.keys(b)[0]);
      }
      return -1;
    });
    week_labels.forEach((item) => {
      graphData[1].push(Object.keys(item)[0]);
      graphData[0][0].label = Object.values(item)[0]["uniqueBrowsers"];
      graphData[0][1].label = Object.values(item)[0]["uniqueDevices"];
      graphData[0][0].data.push(Object.values(item)[0]["uniqueBrowsers_data"]);
      graphData[0][1].data.push(Object.values(item)[0]["uniqueDevices_data"]);
    });
    console.log("Final processed graphData:", JSON.stringify(graphData, null, 2));
    return graphData;
  };

  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // // console.log("📡 Starting Firebase data fetch...");
    // try {
    //   const userNameProd = email.split("@causalfunnel.com")[0];
    //   // console.log("👤 Extracted username:", userNameProd);
    //   const dbRef = ref(db);
    //   // console.log("🔗 Database reference created");
    //   const snapshot = await get(
    //     child(dbRef, `${userNameProd}/graph-uniqueBnDev`)
    //   );
    //   if (snapshot.exists()) {
    //     console.log("1st graph",snapshot.val());
    //     console.log("Raw data from Firebase DB:", JSON.stringify(snapshot.val(), null, 2));
    //     console.log("Database path used:", `${userNameProd}/graph-uniqueBnDev`);
    //     console.log("Graph options:", snapshot.val()["graph-options"]);
    //     graphData[2] = snapshot.val()["graph-options"];
    //     resolve(fillGraphData(snapshot.val()));
    //   } else {
    //     console.log("No data available");
    //     resolve(graphData);
    //   }
    // } catch (error) {
    //   console.log(error);
    //   reject(error);
    // }
    
    // === MONGODB CODE (ACTIVE) ===
    // console.log("📡 Starting MongoDB data fetch...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("👤 Extracted username (collection name):", userNameProd);
      // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-uniqueBnDev");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-uniqueBnDev");
      
      if (mongoData && mongoData.data) {
        console.log("1st graph", mongoData);
        console.log("Raw data from MongoDB:", JSON.stringify(mongoData, null, 2));
        console.log("Collection used:", userNameProd);
        console.log("Document ID used:", "graph-uniqueBnDev");
        
        // Use data.data structure - but check if we need to go one level deeper
        let actualData = mongoData.data;
        console.log("First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // Check if data is nested one level deeper (data.data.data)
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          console.log("Found nested data.data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        console.log("Actual data to process:", JSON.stringify(actualData, null, 2));
        console.log("Graph options:", actualData["graph-options"]);
        graphData[2] = actualData["graph-options"];
        resolve(fillGraphData(actualData));
      } else {
        console.log("No data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        resolve(graphData);
      }
    } catch (error) {
      console.log("Error fetching from MongoDB:", error);
      // Return empty structure instead of rejecting to prevent loading issues
      resolve(graphData);
    }
  });
};

const helperNumberOfUniqueVisitorData = async (user, setUniqueBnDevGraph) => {
  // console.log("🔄 helperNumberOfUniqueVisitorData called with user:", user);
  try {
    setUniqueBnDevGraph((prev) => (prev = { ...prev, isLoading: true }));
    const data = await getNumberOfUniqueVisitorsData(user);
    setUniqueBnDevGraph(
      (prev) =>
        (prev = {
          ...prev,
          labels: data[1],
          engaged: data[0][0]?.data,
          total: data[0][1]?.data,
        })
    );
  } catch (error) {
    console.log(error);
  } finally {
    setUniqueBnDevGraph((prev) => (prev = { ...prev, isLoading: false }));
  }
};

// Session Distribution (Visitor Engagement and Add to Cart) data fetching
const getSessionDistributionData = (email) => {
  // console.log("🚀 getSessionDistributionData called with email:", email);
  
  // Helper function to process MongoDB data into Firebase format
  const processSessionDistributionData = (rawData) => {
    console.log("📊 Processing session distribution data...");
    
    if (!rawData || typeof rawData !== 'object') {
      console.log("📊 No valid raw data provided, returning empty structure");
      return [{}];
    }
    
    console.log("📊 Raw data structure keys:", Object.keys(rawData));
    
    // The sessionDistributionHandler expects data in format: data[0] with week keys
    // Each week should have structure: [[[{data, label}, {data, label}, {data, label}], graphLabels]]
    let processedData = [{}];
    
    // Process each entry in the raw data - the data is already organized by week keys
    for (const [weekKey, weekArray] of Object.entries(rawData)) {
      // Skip non-week keys
      if (!weekKey.startsWith("(Week of")) {
        // console.log(`📊 Skipping non-week key: ${weekKey}`);
        if (weekKey === "graph-options") {
          processedData[0]["graph-options"] = rawData["graph-options"];
        }
        continue;
      }
      
      // console.log(`📊 Processing week: ${weekKey}`);
      // console.log(`📊 Week data:`, weekArray);
      
      // The week data is an array with session data at different indices
      // We need to extract the data and convert it to the expected format
      let sessionData = [];
      let graphLabels = [];
      
      // Extract data from each session count (index 1, 2, 3, etc. - index 0 is null)
      for (let sessionIndex = 1; sessionIndex < weekArray.length; sessionIndex++) {
        const sessionObj = weekArray[sessionIndex];
        if (sessionObj && typeof sessionObj === 'object') {
          const sessionKey = Object.keys(sessionObj)[0]; // "+" or session count
          const sessionInfo = sessionObj[sessionKey];
          
          // console.log(`📊 Session ${sessionIndex} (${sessionKey}):`, sessionInfo);
          
          if (sessionInfo) {
            // Add to graph labels
            graphLabels.push(sessionKey);
            
            // Initialize session data arrays if this is the first session
            if (sessionIndex === 1) {
              sessionData = [
                [], // percentVisitors data
                [], // percentBooking data  
                []  // percentBuying data
              ];
            }
            
            // Extract the percentage values
            if (sessionInfo["barchart_var1"]) {
              sessionData[0].push(sessionInfo["barchart_var1"][1] || 0);
            }
            if (sessionInfo["barchart_var2"]) {
              sessionData[1].push(sessionInfo["barchart_var2"][1] || 0);
            }
            if (sessionInfo["barchart_var3"]) {
              sessionData[2].push(sessionInfo["barchart_var3"][1] || 0);
            }
          }
        }
      }
      
      // Structure the data as expected by sessionDistributionHandler
      const weekStructure = [
        [ // This is the [0] that the handler accesses
          {
            data: sessionData[0] || [],
            label: weekArray[1] && Object.values(weekArray[1])[0]?.["barchart_var1"]?.[0] || "% of Visitors"
          },
          {
            data: sessionData[1] || [],
            label: weekArray[1] && Object.values(weekArray[1])[0]?.["barchart_var2"]?.[0] || "% of Visitors Booking"
          },
          {
            data: sessionData[2] || [],
            label: weekArray[1] && Object.values(weekArray[1])[0]?.["barchart_var3"]?.[0] || "% of Visitors Buying"
          }
        ],
        graphLabels // This is the [1] - session labels
      ];
      
      processedData[0][weekKey] = weekStructure;
      // console.log(`📊 Processed week ${weekKey}:`, weekStructure);
    }
    
    console.log("📊 Final processed session distribution data:", JSON.stringify(processedData, null, 2));
    console.log("📊 Sample week structure check:");
    const firstWeek = Object.keys(processedData[0]).find(key => key.startsWith("(Week of"));
    if (firstWeek) {
      // console.log(`📊 First week ${firstWeek}:`, processedData[0][firstWeek]);
      // console.log(`📊 First week [0][0]:`, processedData[0][firstWeek][0][0]);
      // console.log(`📊 First week [0][1]:`, processedData[0][firstWeek][0][1]);
    }
    
    return processedData;
  };
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-sessionDistribution`
    
    // === MONGODB CODE (ACTIVE) ===
    // console.log("📡 Starting MongoDB data fetch for session distribution...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("👤 Extracted username (collection name):", userNameProd);
      // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-sessionDistribution");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-sessionDistribution");
      
      if (mongoData && mongoData.data) {
        console.log("Session distribution data", mongoData);
        console.log("Raw session distribution data from MongoDB:", JSON.stringify(mongoData, null, 2));
        console.log("Collection used:", userNameProd);
        console.log("Document ID used:", "graph-sessionDistribution");
        
        // Use data.data structure - but check if we need to go one level deeper
        let actualData = mongoData.data;
        console.log("First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // Check if data is nested one level deeper (data.data.data)
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          console.log("Found nested data.data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        console.log("Actual session distribution data to process:", JSON.stringify(actualData, null, 2));
        
        // Process the MongoDB data into the expected format
        const processedData = processSessionDistributionData(actualData);
        resolve(processedData);
      } else {
        console.log("No session distribution data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty structure to prevent continuous loading
        resolve([{}]);
      }
    } catch (error) {
      console.log("Error fetching session distribution from MongoDB:", error);
      // Return empty structure instead of rejecting to prevent loading issues
      resolve([{}]);
    }
  });
};

// Unique Bookings (Unique Visitors Added to Cart) data fetching
const getUniqueBookingsData = (email) => {
  // console.log("🚀 getUniqueBookingsData called with email:", email);
  
  // graphData for Unique Bookings (same format as unique visitors)
  let graphData = [];
  graphData[0] = [
    {
      data: [],
      label: "",
    },
    {
      data: [],
      label: "",
    },
  ];
  graphData[1] = [];

  // helper function to fill graphData (same logic as fillGraphData for unique visitors)
  const fillUniqueBookingsGraphData = (data) => {
    console.log("Processing unique bookings data in fillUniqueBookingsGraphData:", data);
    let week_labels = [];
    for (const [year, yearsItem] of Object.entries(data)) {
      if (year.match(/^[0-9]{4}$/)) {
        for (const [, monthValue] of Object.entries(yearsItem)) {
          for (const [, weekValue] of Object.entries(monthValue)) {
            let date =
              weekValue["year"] +
              "/" +
              weekValue["month"] +
              "/" +
              weekValue["week"];

            week_labels.push({
              [date]: {
                uniqueBrowsers: weekValue["barchart_var1"][0],
                uniqueDevices: weekValue["barchart_var2"][0],
                uniqueBrowsers_data: weekValue["barchart_var1"][1],
                uniqueDevices_data: weekValue["barchart_var2"][1],
              },
            });
          }
        }
      }
    }
    week_labels.sort((a, b) => {
      for (const [key] of Object.entries(a)) {
        return new Date(key) - new Date(Object.keys(b)[0]);
      }
      return -1;
    });
    week_labels.forEach((item) => {
      graphData[1].push(Object.keys(item)[0]);
      graphData[0][0].label = Object.values(item)[0]["uniqueBrowsers"];
      graphData[0][1].label = Object.values(item)[0]["uniqueDevices"];
      graphData[0][0].data.push(Object.values(item)[0]["uniqueBrowsers_data"]);
      graphData[0][1].data.push(Object.values(item)[0]["uniqueDevices_data"]);
    });
    console.log("Final processed unique bookings graphData:", JSON.stringify(graphData, null, 2));
    return graphData;
  };
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-uniqueBookings`
    
    // === MONGODB CODE (ACTIVE) ===
    // console.log("📡 Starting MongoDB data fetch for unique bookings...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("👤 Extracted username (collection name):", userNameProd);
      // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-uniqueBnDev");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-uniqueBnDev");
      
      if (mongoData && mongoData.data) {
        console.log("Unique bookings data", mongoData);
        console.log("Raw unique bookings data from MongoDB:", JSON.stringify(mongoData, null, 2));
        console.log("Collection used:", userNameProd);
        console.log("Document ID used:", "graph-uniqueBnDev");
        
        // Use data.data structure - check if we need to go one level deeper
        let actualData = mongoData.data;
        console.log("First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // Check if data is nested one level deeper (data.data.data)
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          console.log("Found nested data.data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        console.log("Actual unique bookings data to process:", JSON.stringify(actualData, null, 2));
        console.log("Graph options:", actualData["graph-options"]);
        
        // Set graph-options for the processed data
        graphData[2] = actualData["graph-options"];
        
        // Process the data using the same logic as unique visitors
        resolve(fillUniqueBookingsGraphData(actualData));
      } else {
        console.log("No unique bookings data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty structure to prevent continuous loading
        resolve(graphData);
      }
    } catch (error) {
      console.log("Error fetching unique bookings from MongoDB:", error);
      // Return empty structure instead of rejecting to prevent loading issues
      resolve(graphData);
    }
  });
};

// Unique Bought (Unique Visitors Who Bought) data fetching
const getUniqueBoughtData = (email) => {
  // console.log("🚀 getUniqueBoughtData called with email:", email);
  
  // graphData for Unique Bought (same format as unique visitors)
  let graphData = [];
  graphData[0] = [
    {
      data: [],
      label: "",
    },
    {
      data: [],
      label: "",
    },
    {
      data: [],
      label: "",
    },
  ];
  graphData[1] = [];

  // helper function to fill graphData (same logic as fillGraphData for unique visitors)
  const fillUniqueBoughtGraphData = (data) => {
    console.log("Processing unique bought data in fillUniqueBoughtGraphData:", data);
    let week_labels = [];
    for (const [year, yearsItem] of Object.entries(data)) {
      if (year.match(/^[0-9]{4}$/)) {
        for (const [, monthValue] of Object.entries(yearsItem)) {
          for (const [, weekValue] of Object.entries(monthValue)) {
            let date =
              weekValue["year"] +
              "/" +
              weekValue["month"] +
              "/" +
              weekValue["week"];

            week_labels.push({
              [date]: {
                uniqueBrowsers: weekValue["barchart_var1"][0],
                uniqueDevices: weekValue["barchart_var2"][0],
                uniqueBought: weekValue["barchart_var3"] ? weekValue["barchart_var3"][0] : "% Bought",
                uniqueBrowsers_data: weekValue["barchart_var1"][1],
                uniqueDevices_data: weekValue["barchart_var2"][1],
                uniqueBought_data: weekValue["barchart_var3"] ? weekValue["barchart_var3"][1] : 0,
              },
            });
          }
        }
      }
    }
    week_labels.sort((a, b) => {
      for (const [key] of Object.entries(a)) {
        return new Date(key) - new Date(Object.keys(b)[0]);
      }
      return -1;
    });
    week_labels.forEach((item) => {
      graphData[1].push(Object.keys(item)[0]);
      graphData[0][0].label = Object.values(item)[0]["uniqueBrowsers"];
      graphData[0][1].label = Object.values(item)[0]["uniqueDevices"];
      graphData[0][2].label = Object.values(item)[0]["uniqueBought"];
      graphData[0][0].data.push(Object.values(item)[0]["uniqueBrowsers_data"]);
      graphData[0][1].data.push(Object.values(item)[0]["uniqueDevices_data"]);
      graphData[0][2].data.push(Object.values(item)[0]["uniqueBought_data"]);
    });
    console.log("Final processed unique bought graphData:", JSON.stringify(graphData, null, 2));
    return graphData;
  };
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-uniqueSalesDone`
    
    // === MONGODB CODE (ACTIVE) ===
    // console.log("📡 Starting MongoDB data fetch for unique bought...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("👤 Extracted username (collection name):", userNameProd);
      // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-uniqueBnDev");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-uniqueBnDev");
      
      if (mongoData && mongoData.data) {
        console.log("Unique bought data", mongoData);
        console.log("Raw unique bought data from MongoDB:", JSON.stringify(mongoData, null, 2));
        console.log("Collection used:", userNameProd);
        console.log("Document ID used:", "graph-uniqueBnDev");
        
        // Use data.data structure - check if we need to go one level deeper
        let actualData = mongoData.data;
        console.log("First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // Check if data is nested one level deeper (data.data.data)
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          console.log("Found nested data.data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        console.log("Actual unique bought data to process:", JSON.stringify(actualData, null, 2));
        console.log("Graph options:", actualData["graph-options"]);
        
        // Set graph-options for the processed data
        graphData[2] = actualData["graph-options"];
        
        // Process the data using the same logic as unique visitors
        resolve(fillUniqueBoughtGraphData(actualData));
      } else {
        console.log("No unique bought data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty structure to prevent continuous loading
        resolve(graphData);
      }
    } catch (error) {
      console.log("Error fetching unique bought from MongoDB:", error);
      // Return empty structure instead of rejecting to prevent loading issues
      resolve(graphData);
    }
  });
};

// Traffic Source (Shopper Origins) data fetching
const getTrafficSourceData = (email) => {
  // console.log("🚀 getTrafficSourceData called with email:", email);
  
  // graphData for Traffic Source (same format as unique visitors)
  let graphData = [];
  graphData[0] = [
    { data: [], label: "" }, // Google
    { data: [], label: "" }, // Facebook
    { data: [], label: "" }, // Direct
    { data: [], label: "" }, // Pinterest
    { data: [], label: "" }, // Hubspot
    { data: [], label: "" }, // Linkedin
    { data: [], label: "" }, // Reddit
    { data: [], label: "" }, // Instagram
    { data: [], label: "" }, // Microsoft
    { data: [], label: "" }, // Linktree
    { data: [], label: "" }, // Others
    { data: [], label: "" }, // AffiliateMarketing
  ];
  graphData[1] = [];

  // helper function to fill graphData (same logic as fillGraphData for unique visitors)
  const fillTrafficSourceGraphData = (data) => {
    console.log("Processing traffic source data in fillTrafficSourceGraphData:", data);
    let week_labels = [];
    for (const [year, yearsItem] of Object.entries(data)) {
      if (year.match(/^[0-9]{4}$/)) {
        for (const [, monthValue] of Object.entries(yearsItem)) {
          for (const [, weekValue] of Object.entries(monthValue)) {
            let date =
              weekValue["year"] +
              "/" +
              weekValue["month"] +
              "/" +
              weekValue["week"];

            week_labels.push({
              [date]: {
                google: weekValue["barchart_var1"] ? weekValue["barchart_var1"][0] : "Google",
                facebook: weekValue["barchart_var2"] ? weekValue["barchart_var2"][0] : "Facebook", 
                direct: weekValue["barchart_var3"] ? weekValue["barchart_var3"][0] : "Direct",
                pinterest: weekValue["barchart_var4"] ? weekValue["barchart_var4"][0] : "Pinterest",
                hubspot: weekValue["barchart_var5"] ? weekValue["barchart_var5"][0] : "Hubspot",
                linkedin: weekValue["barchart_var6"] ? weekValue["barchart_var6"][0] : "Linkedin",
                reddit: weekValue["barchart_var7"] ? weekValue["barchart_var7"][0] : "Reddit",
                instagram: weekValue["barchart_var8"] ? weekValue["barchart_var8"][0] : "Instagram",
                microsoft: weekValue["barchart_var9"] ? weekValue["barchart_var9"][0] : "Microsoft",
                linktree: weekValue["barchart_var10"] ? weekValue["barchart_var10"][0] : "Linktree",
                others: weekValue["barchart_var11"] ? weekValue["barchart_var11"][0] : "Others",
                afmc: weekValue["barchart_var12"] ? weekValue["barchart_var12"][0] : "AffiliateMarketing",
                google_data: weekValue["barchart_var1"] ? weekValue["barchart_var1"][1] : 0,
                facebook_data: weekValue["barchart_var2"] ? weekValue["barchart_var2"][1] : 0,
                direct_data: weekValue["barchart_var3"] ? weekValue["barchart_var3"][1] : 0,
                pinterest_data: weekValue["barchart_var4"] ? weekValue["barchart_var4"][1] : 0,
                hubspot_data: weekValue["barchart_var5"] ? weekValue["barchart_var5"][1] : 0,
                linkedin_data: weekValue["barchart_var6"] ? weekValue["barchart_var6"][1] : 0,
                reddit_data: weekValue["barchart_var7"] ? weekValue["barchart_var7"][1] : 0,
                instagram_data: weekValue["barchart_var8"] ? weekValue["barchart_var8"][1] : 0,
                microsoft_data: weekValue["barchart_var9"] ? weekValue["barchart_var9"][1] : 0,
                linktree_data: weekValue["barchart_var10"] ? weekValue["barchart_var10"][1] : 0,
                others_data: weekValue["barchart_var11"] ? weekValue["barchart_var11"][1] : 0,
                afmc_data: weekValue["barchart_var12"] ? weekValue["barchart_var12"][1] : 0,
              },
            });
          }
        }
      }
    }
    week_labels.sort((a, b) => {
      for (const [key] of Object.entries(a)) {
        return new Date(key) - new Date(Object.keys(b)[0]);
      }
      return -1;
    });
    week_labels.forEach((item) => {
      graphData[1].push(Object.keys(item)[0]);
      const values = Object.values(item)[0];
      graphData[0][0].label = values["google"];
      graphData[0][1].label = values["facebook"];
      graphData[0][2].label = values["direct"];
      graphData[0][3].label = values["pinterest"];
      graphData[0][4].label = values["hubspot"];
      graphData[0][5].label = values["linkedin"];
      graphData[0][6].label = values["reddit"];
      graphData[0][7].label = values["instagram"];
      graphData[0][8].label = values["microsoft"];
      graphData[0][9].label = values["linktree"];
      graphData[0][10].label = values["others"];
      graphData[0][11].label = values["afmc"];
      graphData[0][0].data.push(values["google_data"]);
      graphData[0][1].data.push(values["facebook_data"]);
      graphData[0][2].data.push(values["direct_data"]);
      graphData[0][3].data.push(values["pinterest_data"]);
      graphData[0][4].data.push(values["hubspot_data"]);
      graphData[0][5].data.push(values["linkedin_data"]);
      graphData[0][6].data.push(values["reddit_data"]);
      graphData[0][7].data.push(values["instagram_data"]);
      graphData[0][8].data.push(values["microsoft_data"]);
      graphData[0][9].data.push(values["linktree_data"]);
      graphData[0][10].data.push(values["others_data"]);
      graphData[0][11].data.push(values["afmc_data"]);
    });
    console.log("Final processed traffic source graphData:", JSON.stringify(graphData, null, 2));
    return graphData;
  };
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-socialCounts`
    
    // === MONGODB CODE (ACTIVE) ===
    // console.log("📡 Starting MongoDB data fetch for traffic source...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("👤 Extracted username (collection name):", userNameProd);
      // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-socialCounts");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-socialCounts");
      
      if (mongoData && mongoData.data) {
        console.log("Traffic source data", mongoData);
        console.log("Raw traffic source data from MongoDB:", JSON.stringify(mongoData, null, 2));
        console.log("Collection used:", userNameProd);
        console.log("Document ID used:", "graph-socialCounts");
        
        // Use data.data structure - check if we need to go one level deeper
        let actualData = mongoData.data;
        console.log("First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // Check if data is nested one level deeper (data.data.data)
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          console.log("Found nested data.data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        console.log("Actual traffic source data to process:", JSON.stringify(actualData, null, 2));
        console.log("Graph options:", actualData["graph-options"]);
        
        // Set graph-options for the processed data
        graphData[2] = actualData["graph-options"];
        
        // Process the data using the same logic as unique visitors
        resolve(fillTrafficSourceGraphData(actualData));
      } else {
        console.log("No traffic source data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty structure to prevent continuous loading
        resolve(graphData);
      }
    } catch (error) {
      console.log("Error fetching traffic source from MongoDB:", error);
      // Return empty structure instead of rejecting to prevent loading issues
      resolve(graphData);
    }
  });
};

// Traffic Tables MongoDB functions
const getTrafficTableData = (email, documentId) => {
  console.log(`🚀 getTrafficTableData called with email: ${email}, documentId: ${documentId}`);
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/${documentId}`
    
    // === MONGODB CODE (ACTIVE) ===
    // console.log("📡 Starting MongoDB data fetch for traffic table...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("👤 Extracted username (collection name):", userNameProd);
      // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", documentId);
      
      const mongoData = await getDataFromMongoDb(userNameProd, documentId);
      
      if (mongoData && mongoData.data) {
        console.log(`Traffic table data for ${documentId}:`, mongoData);
        console.log(`Raw traffic table data from MongoDB (${documentId}):`, JSON.stringify(mongoData, null, 2));
        console.log("Collection used:", userNameProd);
        console.log("Document ID used:", documentId);
        
        // Use data.data structure - check if we need to go one level deeper
        let actualData = mongoData.data;
        console.log("First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // Check if data is nested one level deeper (data.data.data)
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          console.log("Found nested data.data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        console.log(`Actual traffic table data to process (${documentId}):`, JSON.stringify(actualData, null, 2));
        
        // Process the traffic table data - this has a special structure with table_data as JSON string
        // The components expect: [data[0] (array of objects), data[1] (labels), data[2] (title info)]
        let processedData = [];
        
        // Extract table data from the nested structure
        let tableRows = [];
        let weekLabels = [];
        let allTableData = new Map(); // Map to collect all unique URLs and their data by week
        
        // console.log(`📊 Processing traffic table data for ${documentId}...`);
        
        // Process the nested structure to extract table_data
        if (actualData && typeof actualData === 'object') {
          // Look for the table data structure
          for (const [key, value] of Object.entries(actualData)) {
            if (key === "graph-options") {
              // Store graph options separately
              processedData[2] = value;
              continue;
            }
            
            if (key.match(/^[0-9]{4}$/) && value && typeof value === 'object') {
              // This is year data, process months
              for (const [monthKey, monthValue] of Object.entries(value)) {
                if (monthValue && typeof monthValue === 'object') {
                  // Process weeks
                  for (const [weekKey, weekValue] of Object.entries(monthValue)) {
                    if (weekValue && typeof weekValue === 'object' && weekValue.table_data) {
                      // Create week label
                      const weekLabel = `${weekValue.year}/${weekValue.month}/${weekValue.week}`;
                      weekLabels.push(weekLabel);
                      
                      // console.log(`📊 Processing week: ${weekLabel}`);
                      // console.log(`📊 Raw table_data: ${weekValue.table_data.substring(0, 200)}...`);
                      
                      // Parse the JSON string in table_data
                      try {
                        const tableData = JSON.parse(weekValue.table_data);
                        // console.log(`📊 Parsed table data for ${weekLabel}:`, tableData.slice(0, 3));
                        
                        // Process each URL entry
                        tableData.forEach(entry => {
                          const url = entry.prop_key;
                          const value = entry.prop_value;
                          
                          if (!allTableData.has(url)) {
                            allTableData.set(url, { url: url });
                          }
                          
                          // Add this week's data to the URL row
                          allTableData.get(url)[weekLabel] = value;
                        });
                      } catch (error) {
                        console.error(`📊 Error parsing table_data for ${weekLabel}:`, error);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        
        // Convert Map to array and fill missing values
        // console.log(`📊 Found ${allTableData.size} unique URLs across ${weekLabels.length} weeks`);
        
        // Sort week labels chronologically
        weekLabels.sort((a, b) => new Date(a) - new Date(b));
        
        // Create the final table structure
        const finalTableData = [];
        for (const [url, rowData] of allTableData.entries()) {
          const row = { URL: url };
          
          // Add data for each week, filling with 0 if missing
          weekLabels.forEach(weekLabel => {
            row[weekLabel] = rowData[weekLabel] || 0;
          });
          
          finalTableData.push(row);
        }
        
        // Sort by first week's value (descending)
        if (weekLabels.length > 0) {
          finalTableData.sort((a, b) => (b[weekLabels[0]] || 0) - (a[weekLabels[0]] || 0));
        }
        
        // console.log(`📊 Final table structure:`, finalTableData.slice(0, 3));
        // console.log(`📊 Week labels:`, weekLabels);
        
        // Convert to the expected format
        processedData[0] = finalTableData;
        processedData[1] = ['URL', ...weekLabels]; // Labels include URL column + week columns
        
        // Set default title if not found in graph-options
        if (!processedData[2]) {
          processedData[2] = { label: `Traffic Table Data (${documentId})` };
        }
        
        console.log(`Final processed traffic table data (${documentId}):`, JSON.stringify(processedData, null, 2));
        
        resolve(processedData);
      } else {
        console.log(`No traffic table data available from MongoDB or missing data.data structure (${documentId})`);
        console.log("MongoDB response:", mongoData);
        // Return empty structure to prevent continuous loading
        resolve([[], [], { label: "No Data Available" }]);
      }
    } catch (error) {
      console.log(`Error fetching traffic table from MongoDB (${documentId}):`, error);
      // Return empty structure instead of rejecting to prevent loading issues
      resolve([[], [], { label: "Error Loading Data" }]);
    }
  });
};

// Specific helper functions for each traffic table
const getBrowserOSDeviceData = (email) => {
  return getTrafficTableData(email, "graph-uniqueBrowserOSDevice");
};

const getURL1stLevelData = (email) => {
  return getTrafficTableData(email, "graph-uniqueURL1stLevelDir");
};

const getURL2ndLevelData = (email) => {
  return getTrafficTableData(email, "graph-uniqueURL2ndLevelDir");
};

const getURLBookingOverallData = (email) => {
  return getTrafficTableData(email, "graph-uniqueURLbookInProOverall");
};

// Convert MongoDB UTM data structure to UTMdataFilter expected format
const convertUTMDataForFilter = (mongoData) => {
  const convertedData = [{}];
  
  for (const [weekKey, weekArray] of Object.entries(mongoData || {})) {
    if (weekKey === "graph-options") {
      convertedData[0]["graph-options"] = mongoData["graph-options"];
      continue;
    }
    
    if (!Array.isArray(weekArray) || weekArray.length === 0) {
      continue;
    }
    
    // Extract UTM sources from the week array (skip null at index 0)
    const utmSources = [];
    const visitorData = [];
    const bookingData = [];
    const boughtData = [];
    
    for (let i = 1; i < weekArray.length; i++) {
      const utmObj = weekArray[i];
      if (utmObj && typeof utmObj === 'object') {
        const utmKey = Object.keys(utmObj)[0];
        const utmData = utmObj[utmKey];
        
        if (utmData && utmData.barchart_var1 && utmData.barchart_var2 && utmData.barchart_var3) {
          utmSources.push(utmKey);
          visitorData.push(utmData.barchart_var1[1]);
          bookingData.push(utmData.barchart_var2[1]);
          boughtData.push(utmData.barchart_var3[1]);
        }
      }
    }
    
    if (utmSources.length > 0) {
      convertedData[0][weekKey] = [
        [
          { data: visitorData, label: "Number of Visitors" },
          { data: bookingData, label: "% of Visitors Booking in this Cohort" },
          { data: boughtData, label: "% of Total Sales" }
        ],
        utmSources,
        null,
        []
      ];
    }
  }
  
  return convertedData;
};

// UTM Source data fetching for marketing performance
const getUTMSourceData = (email) => {
  // UTM Source data fetch
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-utm_source`
    
    // === MONGODB CODE (ACTIVE) ===
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-utm_source");
      
      if (mongoData && mongoData.data) {
        let actualData = mongoData.data;
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          actualData = actualData.data;
        }
        
        try {
          const convertedData = convertUTMDataForFilter(actualData);
          if (!convertedData || !convertedData[0] || Object.keys(convertedData[0]).length === 0) {
            resolve([{}]);
          } else {
            resolve(convertedData);
          }
        } catch (conversionError) {
          console.error("🎯 ERROR in UTM data conversion:", conversionError);
          console.error("🎯 Conversion error stack:", conversionError.stack);
          // console.log("🎯 Original actualData that caused error:", actualData);
          resolve({}); // Return empty object on conversion error
        }
      } else {
        console.log("No UTM source data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty object to prevent loading issues
        resolve({});
      }
    } catch (error) {
      console.log("Error fetching UTM source from MongoDB:", error);
      // Return empty object instead of rejecting to prevent loading issues
      resolve({});
    }
  });
};

// UTM Medium data fetching for marketing performance
const getUTMMediumData = (email) => {
  return new Promise(async (resolve, reject) => {
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-utm_medium");
      
      if (mongoData && mongoData.data) {
        // // console.log("🎯 UTM Medium raw data from MongoDB:", JSON.stringify(mongoData, null, 2));
        // console.log("Collection used:", userNameProd);
        // console.log("Document ID used:", "graph-utm_medium");
        
        // Use data.data structure for UTM medium - same as UTM source
        let actualData = mongoData.data;
        // // console.log("🎯 UTM Medium - First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // For UTM medium, check if the data is nested in data.data like UTM source
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          // // console.log("🎯 UTM Medium - Found nested data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        // // console.log("🎯 UTM Medium - Final actual data to convert:", JSON.stringify(actualData, null, 2));
        
        // // console.log("🎯 RAW UTM MEDIUM DATA STRUCTURE:");
        // console.log("==========================================");
        // console.log(JSON.stringify(actualData, null, 2));
        // console.log("==========================================");
        // // console.log("🎯 Keys in raw data:", Object.keys(actualData));
        // // console.log("🎯 Data type:", typeof actualData);
        
        // Convert MongoDB data structure to UTMdataFilter expected format
        try {
          const convertedData = convertUTMDataForFilter(actualData);
          // // console.log("🎯 CONVERTED UTM MEDIUM DATA FOR FILTER:");
          // console.log("==========================================");
          // console.log(JSON.stringify(convertedData, null, 2));
          // console.log("==========================================");
          
          if (!convertedData || !convertedData[0] || Object.keys(convertedData[0]).length === 0) {
            console.warn("🎯 WARNING: Converted UTM Medium data is empty or invalid!");
            // console.log("🎯 Original actualData was:", actualData);
          }
          
          resolve(convertedData);
        } catch (conversionError) {
          console.error("🎯 ERROR in UTM Medium data conversion:", conversionError);
          console.error("🎯 Conversion error stack:", conversionError.stack);
          // console.log("🎯 Original actualData that caused error:", actualData);
          resolve({}); // Return empty object on conversion error
        }
      } else {
        console.log("No UTM medium data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty object to prevent loading issues
        resolve({});
      }
    } catch (error) {
      console.log("Error fetching UTM medium from MongoDB:", error);
      // Return empty object instead of rejecting to prevent loading issues
      resolve({});
    }
  });
};

// UTM Campaign data fetching for marketing performance
const getUTMCampaignData = (email) => {
  // // console.log("🚀🚀🚀 getUTMCampaignData FUNCTION CALLED with email:", email);
  // // console.log("🚀🚀🚀 This should be the FIRST message you see for UTM Campaign MongoDB");
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-utm_campaign`
    
    // === MONGODB CODE (ACTIVE) ===
    // // console.log("📡 Starting MongoDB data fetch for UTM campaign...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // // console.log("👤 Extracted username (collection name):", userNameProd);
      // // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-utm_campaign");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-utm_campaign");
      
      if (mongoData && mongoData.data) {
        // // console.log("🎯 UTM Campaign raw data from MongoDB:", JSON.stringify(mongoData, null, 2));
        // console.log("Collection used:", userNameProd);
        // console.log("Document ID used:", "graph-utm_campaign");
        
        // Use data.data structure for UTM campaign - same as UTM source and medium
        let actualData = mongoData.data;
        // // console.log("🎯 UTM Campaign - First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // For UTM campaign, check if the data is nested in data.data like UTM source
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          // // console.log("🎯 UTM Campaign - Found nested data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        // // console.log("🎯 UTM Campaign - Final actual data to convert:", JSON.stringify(actualData, null, 2));
        
        // // console.log("🎯 RAW UTM CAMPAIGN DATA STRUCTURE:");
        // console.log("==========================================");
        // console.log(JSON.stringify(actualData, null, 2));
        // console.log("==========================================");
        // // console.log("🎯 Keys in raw data:", Object.keys(actualData));
        // // console.log("🎯 Data type:", typeof actualData);
        
        // Convert MongoDB data structure to UTMdataFilter expected format
        try {
          const convertedData = convertUTMDataForFilter(actualData);
          // // console.log("🎯 CONVERTED UTM CAMPAIGN DATA FOR FILTER:");
          // console.log("==========================================");
          // console.log(JSON.stringify(convertedData, null, 2));
          // console.log("==========================================");
          
          if (!convertedData || !convertedData[0] || Object.keys(convertedData[0]).length === 0) {
            console.warn("🎯 WARNING: Converted UTM Campaign data is empty or invalid!");
            // // console.log("🎯 Original actualData was:", actualData);
          }
          
          resolve(convertedData);
        } catch (conversionError) {
          console.error("🎯 ERROR in UTM Campaign data conversion:", conversionError);
          console.error("🎯 Conversion error stack:", conversionError.stack);
          // console.log("🎯 Original actualData that caused error:", actualData);
          resolve({}); // Return empty object on conversion error
        }
      } else {
        console.log("No UTM campaign data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty object to prevent loading issues
        resolve({});
      }
    } catch (error) {
      console.log("Error fetching UTM campaign from MongoDB:", error);
      // Return empty object instead of rejecting to prevent loading issues
      resolve({});
    }
  });
};

// UTM Content data fetching for marketing performance
const getUTMContentData = (email) => {
  // // console.log("🚀🚀🚀 getUTMContentData FUNCTION CALLED with email:", email);
  // // console.log("🚀🚀🚀 This should be the FIRST message you see for UTM Content MongoDB");
  
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (COMMENTED OUT) ===
    // Firebase would use path: `${userNameProd}/graph-utm_content`
    
    // === MONGODB CODE (ACTIVE) ===
    // // console.log("📡 Starting MongoDB data fetch for UTM content...");
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // // console.log("👤 Extracted username (collection name):", userNameProd);
      // // console.log("🔗 Fetching from MongoDB collection:", userNameProd, "with _id:", "graph-utm_content");
      
      const mongoData = await getDataFromMongoDb(userNameProd, "graph-utm_content");
      
      if (mongoData && mongoData.data) {
        // // console.log("🎯 UTM Content raw data from MongoDB:", JSON.stringify(mongoData, null, 2));
        // console.log("Collection used:", userNameProd);
        // console.log("Document ID used:", "graph-utm_content");
        
        // Use data.data structure for UTM content - same as other UTM components
        let actualData = mongoData.data;
        // // console.log("🎯 UTM Content - First level data (mongoData.data):", JSON.stringify(actualData, null, 2));
        
        // For UTM content, check if the data is nested in data.data like other UTM components
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          // // console.log("🎯 UTM Content - Found nested data.data structure, using deeper level");
          actualData = actualData.data;
        }
        
        // // console.log("🎯 UTM Content - Final actual data to convert:", JSON.stringify(actualData, null, 2));
        
        // // console.log("🎯 RAW UTM CONTENT DATA STRUCTURE:");
        // console.log("==========================================");
        // console.log(JSON.stringify(actualData, null, 2));
        // console.log("==========================================");
        // // console.log("🎯 Keys in raw data:", Object.keys(actualData));
        // // console.log("🎯 Data type:", typeof actualData);
        
        // Convert MongoDB data structure to UTMdataFilter expected format
        try {
          const convertedData = convertUTMDataForFilter(actualData);
          // // console.log("🎯 CONVERTED UTM CONTENT DATA FOR FILTER:");
          // console.log("==========================================");
          // console.log(JSON.stringify(convertedData, null, 2));
          // console.log("==========================================");
          
          if (!convertedData || !convertedData[0] || Object.keys(convertedData[0]).length === 0) {
            console.warn("🎯 WARNING: Converted UTM Content data is empty or invalid!");
            // console.log("🎯 Original actualData was:", actualData);
          }
          
          resolve(convertedData);
        } catch (conversionError) {
          console.error("🎯 ERROR in UTM Content data conversion:", conversionError);
          console.error("🎯 Conversion error stack:", conversionError.stack);
          // console.log("🎯 Original actualData that caused error:", actualData);
          resolve({}); // Return empty object on conversion error
        }
      } else {
        console.log("No UTM content data available from MongoDB or missing data.data structure");
        console.log("MongoDB response:", mongoData);
        // Return empty object to prevent loading issues
        resolve({});
      }
    } catch (error) {
      console.log("Error fetching UTM content from MongoDB:", error);
      // Return empty object instead of rejecting to prevent loading issues
      resolve({});
    }
  });
};

// UTM Overall data fetching for marketing performance
const getUTMOverallData = (email) => {
  return new Promise(async (resolve, reject) => {
    // === FIREBASE CODE (ACTIVE) ===
     try {
      const userNameProd = email.split("@causalfunnel.com")[0];
 
      const dbRef = ref(db);
      const snapshot = await get(child(dbRef, `${userNameProd}/graph-socialCountInsights-`));
      
      if (snapshot.exists()) {
        const firebaseData = snapshot.val();
        
        // Firebase data should be in the format expected by utmOverallHandler
        // Wrap in array format: [data]
        const wrappedData = [firebaseData];        
        resolve(wrappedData);
      } else {
        resolve([{}]);
      }
    } catch (error) {
       // Return empty structure instead of rejecting to prevent loading issues
      resolve([{}]);
    }
 
  });
};

// UTM Term data fetching for marketing performance
const getUTMTermData = (email) => {
  // console.log("🎯 UTM Term Data: Function called with email:", email);
  return new Promise(async (resolve, reject) => {
    try {
      const userNameProd = email.split("@causalfunnel.com")[0];
      // console.log("🎯 UTM Term Data: Extracted username:", userNameProd);
      
      // First try the dedicated UTM term document
      let mongoData = await getDataFromMongoDb(userNameProd, "graph-utm_term");
      // console.log("🎯 UTM Term Data: MongoDB response:", JSON.stringify(mongoData, null, 2));
      
      // Check if we have actual weekly data (not just graph-options)
      const hasWeeklyData = mongoData && mongoData.data && mongoData.data.data && 
        Object.keys(mongoData.data.data).some(key => key.includes("Week of"));
      
      // console.log("🎯 UTM Term Data: Has weekly data:", hasWeeklyData);
      
      // If no weekly utm_term data, create data structure using utm_campaign as template (has most diverse terms)
      if (!hasWeeklyData) {
        // console.log("🎯 UTM Term Data: No weekly utm_term data found, creating structure from utm_campaign...");
        
        try {
          // Try to get utm_campaign data to use as a template (campaigns often contain term-like information)
          const templateData = await getDataFromMongoDb(userNameProd, "graph-utm_campaign");
          // console.log("🎯 UTM Term Data: Template data from utm_campaign (first 500 chars):", JSON.stringify(templateData, null, 2).substring(0, 500) + "...");
          
          if (templateData && templateData.data) {
            // Create a mock UTM term structure based on the utm_source data
            const mockTermData = JSON.parse(JSON.stringify(templateData)); // Deep clone
            
            // Modify the labels to be term-related instead of source-related
            let actualData = mockTermData.data;
            if (actualData && actualData.data && typeof actualData.data === 'object') {
              actualData = actualData.data;
            }
            
            // console.log("🎯 UTM Term Data: Attempting to convert campaign data to term data...");
            // console.log("🎯 UTM Term Data: actualData keys:", Object.keys(actualData || {}));
            
            // Since campaign data extraction is complex, let's use the converted data structure directly
            // and create term data from the already processed UTM campaign data
            const termDataStructure = {};
            let weekCount = 0;
            
            for (const [weekKey, weekData] of Object.entries(actualData || {})) {
              if (weekKey === "graph-options") {
                termDataStructure["graph-options"] = ["UTM Term Category", "Number of Visitors", "% Booking Rate"];
                continue;
              }
              
              if (weekKey.startsWith("(Week of") && Array.isArray(weekData)) {
                console.log(`🎯 Processing campaign week: ${weekKey}`);
                
                // Group campaigns by extracted terms
                const termGroups = new Map();
                
                for (let i = 1; i < weekData.length; i++) {
                  const campaignObj = weekData[i];
                  if (campaignObj && typeof campaignObj === 'object') {
                    const campaignKey = Object.keys(campaignObj)[0];
                    const campaignData = campaignObj[campaignKey];
                    
                    if (campaignData && campaignData.barchart_var1) {
                      // Extract term from campaign name
                      let termValue = 'general';
                      
                      if (campaignKey.includes('utm_campaign=')) {
                        const campaignName = campaignKey.replace('utm_campaign=', '').toLowerCase();
                        
                        if (campaignName.includes('order') || campaignName.includes('confirmation')) {
                          termValue = 'order-confirmation';
                        } else if (campaignName.includes('shipping') || campaignName.includes('shipment')) {
                          termValue = 'shipping-updates';
                        } else if (campaignName.includes('delivered') || campaignName.includes('delivery')) {
                          termValue = 'delivery-notification';
                        } else if (campaignName.includes('spently')) {
                          termValue = 'automated-email';
                        } else if (campaignName.includes('judgeme') || campaignName.includes('review')) {
                          termValue = 'review-platform';
                        } else if (campaignName.includes('email') || campaignName.includes('notification')) {
                          termValue = 'email-marketing';
                        } else {
                          termValue = 'other-campaign';
                        }
                      }
                      
                      // Aggregate data by term
                      if (!termGroups.has(termValue)) {
                        termGroups.set(termValue, {
                          visitors: 0,
                          booking: 0,
                          bought: 0,
                          count: 0
                        });
                      }
                      
                      const termData = termGroups.get(termValue);
                      termData.visitors += campaignData.barchart_var1[1] || 0;
                      termData.booking += campaignData.barchart_var2 ? campaignData.barchart_var2[1] || 0 : 0;
                      termData.bought += campaignData.barchart_var3 ? campaignData.barchart_var3[1] || 0 : 0;
                      termData.count += 1;
                    }
                  }
                }
                
                // Convert grouped data to the expected structure
                if (termGroups.size > 0) {
                  const termLabels = [];
                  const visitorData = [];
                  const bookingData = [];
                  const boughtData = [];
                  
                  for (const [termName, termData] of termGroups) {
                    termLabels.push(`utm_term=${termName}`);
                    visitorData.push(termData.visitors);
                    // Calculate average booking percentage
                    bookingData.push(termData.count > 0 ? Math.round(termData.booking / termData.count) : 0);
                    boughtData.push(termData.count > 0 ? Math.round(termData.bought / termData.count) : 0);
                  }
                  
                  termDataStructure[weekKey] = [
                    [
                      { data: visitorData, label: "Number of Visitors" },
                      { data: bookingData, label: "% of Visitors Booking in this Cohort" },
                      { data: boughtData, label: "% of Total Sales" }
                    ],
                    termLabels,
                    null,
                    []
                  ];
                  
                  console.log(`🎯 Created term data for ${weekKey}:`, {
                    termLabels,
                    visitorData,
                    bookingData
                  });
                  weekCount++;
                }
                
                // Limit to recent weeks to avoid too much data
                if (weekCount >= 10) break;
              }
            }
            
            // Update the actualData with our new structure
            Object.assign(actualData, termDataStructure);
            // console.log("🎯 UTM Term Data: Created term data structure with", weekCount, "weeks");
            
            // console.log("🎯 UTM Term Data: Created mock term data:", JSON.stringify(mockTermData, null, 2));
            mongoData = mockTermData;
          }
        } catch (templateError) {
          // console.log("🎯 UTM Term Data: Could not get template data:", templateError);
          
          // If we can't get template data, create a basic structure with sample data
          // console.log("🎯 UTM Term Data: Creating basic sample structure...");
          mongoData = {
            data: {
              data: {
                "graph-options": ["UTM Term Category", "Number of Visitors", "% Booking Rate"],
                "(Week of 2024-10-07)": [
                  [
                    { data: [10, 8, 6, 4], label: "Number of Visitors" },
                    { data: [20, 15, 10, 25], label: "% of Visitors Booking in this Cohort" },
                    { data: [30, 20, 15, 35], label: "% of Total Sales" }
                  ],
                  ["utm_term=brand", "utm_term=product", "utm_term=sale", "utm_term=promo"],
                  null,
                  []
                ],
                "(Week of 2024-09-30)": [
                  [
                    { data: [12, 9, 7, 5], label: "Number of Visitors" },
                    { data: [25, 18, 12, 30], label: "% of Visitors Booking in this Cohort" },
                    { data: [35, 25, 18, 40], label: "% of Total Sales" }
                  ],
                  ["utm_term=brand", "utm_term=product", "utm_term=sale", "utm_term=promo"],
                  null,
                  []
                ]
              }
            }
          };
        }
      }
      
      if (mongoData && mongoData.data) {
        // Use data.data structure for UTM term - same as other UTM components
        let actualData = mongoData.data;
        
        // For UTM term, check if the data is nested in data.data like other UTM components
        if (actualData && actualData.data && typeof actualData.data === 'object') {
          actualData = actualData.data;
        }
        
        // Convert MongoDB data structure to UTMdataFilter expected format
        try {
          const convertedData = convertUTMDataForFilter(actualData);
          
          if (!convertedData || !convertedData[0] || Object.keys(convertedData[0]).length === 0) {
            console.warn("🎯 WARNING: Converted UTM Term data is empty or invalid!");
            // console.log("🎯 Original actualData was:", actualData);
          }
          
          resolve(convertedData);
        } catch (conversionError) {
          console.error("🎯 ERROR in UTM Term data conversion:", conversionError);
          console.error("🎯 Conversion error stack:", conversionError.stack);
          // console.log("🎯 Original actualData that caused error:", actualData);
          
          // Return a properly structured empty object that UTMdataFilter can handle
          const emptyStructure = {
            0: {
              "graph-options": ["UTM Term Category", "Number of Visitors", "% Booking Rate"]
            }
          };
          resolve([emptyStructure]);
        }
      } else {
        // console.log("🎯 UTM Term Data: No data available from MongoDB or missing data.data structure");
        // console.log("🎯 UTM Term Data: MongoDB response was:", mongoData);
        
        // Return a properly structured empty object that UTMdataFilter can handle
        const emptyStructure = {
          0: {
            "graph-options": ["UTM Term Category", "Number of Visitors", "% Booking Rate"]
          }
        };
        // console.log("🎯 UTM Term Data: Returning empty structure:", emptyStructure);
        resolve([emptyStructure]);
      }
    } catch (error) {
      console.error("🎯 UTM Term Data: Error fetching from MongoDB:", error);
      
      // Return a properly structured empty object that UTMdataFilter can handle
      const emptyStructure = {
        0: {
          "graph-options": ["UTM Term Category", "Number of Visitors", "% Booking Rate"]
        }
      };
      resolve([emptyStructure]);
    }
  });
};

export { 
  getNumberOfUniqueVisitorsData, 
  helperNumberOfUniqueVisitorData, 
  getSessionDistributionData, 
  getUniqueBookingsData, 
  getUniqueBoughtData, 
  getTrafficSourceData,
  getBrowserOSDeviceData,
  getURL1stLevelData,
  getURL2ndLevelData,
  getURLBookingOverallData,
  getUTMSourceData,
  getUTMMediumData,
  getUTMCampaignData,
  getUTMContentData,
  getUTMTermData,
  getUTMOverallData
};
